import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const MODELS = [
  { id: "claude-sonnet-5", label: "Claude Sonnet 5", provider: "Anthropic" },
  { id: "gpt-5.4-mini", label: "GPT-5.4 Mini", provider: "OpenAI" },
];

export default function ModelPicker({ value, onChange, testId = "model-picker", size = "default" }) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger data-testid={testId} className={size === "sm" ? "h-8 text-xs" : ""}>
        <SelectValue placeholder="Model" />
      </SelectTrigger>
      <SelectContent>
        {MODELS.map((m) => (
          <SelectItem key={m.id} value={m.id} data-testid={`model-opt-${m.id}`}>
            <span className="font-medium">{m.label}</span>
            <span className="text-slate-400 ml-2 text-xs font-mono-plex">· {m.provider}</span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
